// Do not touch this file, auto-generated by scripts/create-version
export const VERSION = "1.3.22"
